<template>
  <!-- :bodyStyle="{paddingTop:'10px'}" -->
  <a-card :bordered="false" :headStyle="{borderBottom:'0px',fontSize:'18px',paddingLeft:'24px'}">
    <search-page-view
      ref="table"
      rowKey="groupId"
      :columns="columns"
      :enableSearch="false"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
    >
      <a-form-item slot="operation">
        <a-input-search placeholder="请输入商品名称" @search="onSearch" style="max-width: 400px;"/>
      </a-form-item>
      <template slot="planSlots" slot-scope="data">
        <span>{{ data.record.groupParticipateQuantity }}/{{ data.record.groupSucceedQuantity }}</span>
      </template>
      <div slot="action" slot-scope="data">
        <a @click="lookEvent(data.record.groupId)">查看</a>
      </div>
    </search-page-view>
  </a-card>
</template>

<script>
export default {
  name: 'GroupOrderList',
  components: {},
  data() {
    return {
      submitLoading: false,
      currentFormLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      queryParams: {
        proName: ''
      },
      loadPromise: params => this.getListPromise(params),
      columns: [
        {
          title: '拼团ID',
          dataIndex: 'groupId'
        },
        {
          title: '商品名称',
          dataIndex: 'groupProName',
          width: '30%'
        },
        {
          title: '拼团套餐',
          dataIndex: 'groupOptionName'
        },
        {
          title: '拼团进度',
          dataIndex: '',
          scopedSlots: { customRender: 'planSlots' }
        },
        {
          title: '更新时间',
          dataIndex: 'groupUpdateTime'
        },
        {
          title: '结束时间',
          dataIndex: 'groupMaturityTime'
        },
        {
          title: '状态',
          dataIndex: 'groupStatusStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '120px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  },
  mounted() {

  },
  activated() {
    this.getLogUtils().logWithTag('拼团activated')
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'GroupServiceList', title: '拼团商品' },
      { name: 'GroupOrderList', title: '拼团订单' }
    ])
    if (this.$route.query.updateFlag) {
      this.getLogUtils().logWithTag('activated', this.$route.query.updateFlag)
      this.$refs.table.refresh(true)
    }
  },
  methods: {
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getOrderListPromise==', params)
      return this.getHttpServices().getOrderService().post('group/order/list', params)
    },
    onSearch(value) {
      this.queryParams.proName = value
      this.$refs.table.refresh(true)
    },
    // 新增内容
    lookEvent(groupId) {
      this.$router.push({
        name: 'GroupOrderDetails',
        query: {
          groupId: groupId,
          serverUniqueId: this.$route.query.serverUniqueId
        }
      })
    }
  }

}
</script>
<style scoped lang="less">
.herder-set {
  text-align: right;
  float: right;

  a {
    padding-left: 10px;
  }
}

.title-text {
  height: 26px;
  line-height: 26px;
  font-size: 16px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.65);
  padding-left: 15px;
}

.w100 {
  width: 100px;
  height: 100px;
}
</style>